import { BellRing, Link, Megaphone } from 'lucide-react'
import React from 'react'
import MyTabs from '../../../tools/MyTabs'
import Deeplink from './Deeplink'
import FirebaseConfig from './FirebaseConfig'

export default function AppConfig() {
  return (
    <div className='space-y-0'>
         <MyTabs
        position="left"
        tabs={[
          {
            label: "Deeplink",
            content: <Deeplink />,
            icon: Link,
          },
          {
            label: "App Ads",
        //    content: <PolicyPage />,
            icon: Megaphone,
          },
          {
            label: "Firebase",
            content: <FirebaseConfig />,
            icon: BellRing,
          },
        ]}
      />
    </div>
  )
}
